export default "__VITE_ASSET__KAeIS3DT__"